<template>
	<v-row dense>
		<template v-if="usesUnitWeightMethod">
			<v-col cols="12">
				<v-text-field
					dense
					outlined
					hide-details="auto"
					v-model="row.unitWeightKg"
					type="number"
					min="0"
					step="0.001"
					label="Unit weight (kg/unit)"
					placeholder="e.g. 0.025"
				/>
			</v-col>
			<v-col cols="12">
				<v-text-field
					dense
					outlined
					hide-details="auto"
					v-model="row.quantity"
					type="number"
					min="0"
					label="Annual quantity (units/year)"
					placeholder="e.g. 100000"
				/>
			</v-col>
			<v-col cols="12">
				<v-text-field
					dense
					outlined
					readonly
					hide-details="auto"
					:value="formatRowWeight(row)"
					label="Total weight (kg/year)"
				/>
			</v-col>
		</template>
		<v-col v-else cols="12">
			<v-text-field
				dense
				outlined
				hide-details="auto"
				v-model="row.totalWeightKg"
				type="number"
				min="0"
				label="Total annual weight (kg/year)"
				placeholder="e.g. 3000"
			/>
		</v-col>
		<v-col cols="12">
			<v-text-field
				dense
				outlined
				hide-details="auto"
				v-model="row.recycledContentPct"
				type="number"
				min="0"
				max="100"
				label="Recycled content at purchase (%)"
				placeholder="0–100"
			/>
		</v-col>
		<v-col cols="12">
			<v-text-field
				dense
				outlined
				hide-details="auto"
				v-model="row.recycledAfterUsePct"
				type="number"
				min="0"
				max="100"
				label="Recycled after use (%)"
				placeholder="0–100"
			/>
		</v-col>
		<v-col cols="12" v-if="showEndOfLife(row)">
			<v-select
				dense
				outlined
				hide-details="auto"
				v-model="row.endOfLife"
				:items="endOfLifeOptions"
				label="End-of-life for non-recycled share"
				placeholder="Use global default"
				clearable
			/>
		</v-col>
	</v-row>
</template>

<script>
export default {
	name: "PackagingMaterialFields",
	props: {
		row: {
			type: Object,
			required: true,
		},
		usesUnitWeightMethod: Boolean,
		endOfLifeOptions: {
			type: Array,
			default: () => [],
		},
		formatRowWeight: {
			type: Function,
			required: true,
		},
		showEndOfLife: {
			type: Function,
			required: true,
		},
	},
}
</script>
